/* eslint-disable max-len */
// /* eslint-disable max-len */
// /* eslint-disable security/detect-object-injection */
// /* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { useEditObserverMutation, useExportObserversListMutation ,useDeleteObserverMutation} from "../../slices/observerSlice"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRowsConditionally"
import Table from "./Components/Table"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { useGetObserversQuery } from "../../slices/observerSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import TopBarIndividual from './TopBar/index'
import moment from "moment"
import { handleAddFilterValues, handleSidebarPrvState, handleSystemConfig } from "../../redux/systemConfigSlice"
import { pushToSubDivArray, popFromSubDivArray } from "../ManagePatient/AddPatient/Components/subdivisionSlice"

import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { dataService } from "../../services/data.services"
import OrganizationUserSearch from "../ManageOrganizationUsers/AdvancedSearch"
import { resetOrgUserSearch, setOrgUserSearchApplied } from "../../redux/orgUserSearchSlice"

export default function ManageObserver() {
    const { setToastmessage, setToastErrorMessage, isSideBar, setIsSideBar, isAdvancedSearchOpen, setIsAdvancedSearchOpen } = useContext(GlobalContext);

    const [editObserver] = useEditObserverMutation()
    const [deleteObserver]=useDeleteObserverMutation()
    const [exportObservers] = useExportObserversListMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)
    const selectedRows = useSelector(state => state.MultiSelectSliceConditionally.selectedRows.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const auth = useSelector(state => state.auth)
    const { userType } = auth
    const checkedArr = useSelector(state => state.userSelect.selectedUsers.checkedArr)
    const [subDivisionDataLoading, setSubDivisionDataLoading] = useState(false)
    const userArr = useSelector(state => state.subdivSelect.subdivData.checkedArr)
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const [multiDelete, setMultiDelete] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const searchApplied = useSelector((state) => state.orgUserSearchData.org_user_searchApplied);
    const organizationUserSearch = useSelector(state => state.orgUserSearchData);
    const [datePartialFilled,setDatePartialFilled] = useState(false);
    
    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });
    const initialState = {
        "start_date": '',
        "end_date": '',
        "subdivision_ids": [],
        "status": []
    }
    const [filterValues, setFilterValues] = useState(initialState)
    const { data, isFetching, isLoading, status } = useGetObserversQuery(searchParams?.toString(), { skip: skip || location.search === '' })
    const hasFilters = searchParams.get('status') !== null || searchParams.get('start_date') !== null || searchParams.get('end_date') !== null || searchParams.get('organization_id') !== null || searchParams.get('subdivision_ids') !== null;
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }
    
    
    useEffect(() => {
        if (location.search === '') {
            setSkip(true);
        }
    
        if (location.state && typeof location.state === 'object' && !Array.isArray(location.state)) {
            let currentParams = Object.fromEntries(searchParams); // Get existing search params

            // Carry every incoming param through (status/start_date/end_date/subdivision_ids/filter),
            // dropping only the non-URL extras the View/Edit screens attach to the state object.
            const NON_URL_KEYS = ['fromScreen', 'true', 'id', 'user_id', 'object_id'];
            const incoming = Object.fromEntries(
                Object.entries(location.state).filter(([key, value]) =>
                    !NON_URL_KEYS.includes(key) && value !== undefined && value !== null && value !== ''
                )
            );

            let params = {
                limit: '15',
                page_number: '1',
                sort: 'created_at+desc',
                filter: 'true',
                ...incoming,
            };

            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search

            // Only update params if they actually changed (prevents unnecessary re-renders)
            if (JSON.stringify(currentParams) !== JSON.stringify(params)) {
                setSearchParams(params, { replace: true });
            }

            // An advanced search was active on the listing, so reopen the panel on return.
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        } else {
            let updatedParams = { ...Object.fromEntries(searchParams) };
    
            if (!updatedParams.limit) updatedParams.limit = '15';
            if (!updatedParams.page_number) updatedParams.page_number = searchParams.get('page_number') || '1';
            if (!updatedParams.sort) updatedParams.sort = 'created_at+desc';
            if (!updatedParams.filter) updatedParams.filter = 'true';
    
            // Only update params if they changed
            if (JSON.stringify(Object.fromEntries(searchParams)) !== JSON.stringify(updatedParams)) {
                setSearchParams(updatedParams, { replace: true });
            }
        }
    
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '');
    }, [location]);
    

    useEffect(() => {
        if (searchParams.size >= 4) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        const start_date = moment(filterValues?.start_date).format('YYYY-MM-DD')
        const end_date = moment(filterValues?.end_date).format('YYYY-MM-DD')
        if (type) {
            dispatch(handleAddFilterValues({
                "start_date": filterValues.start_date,
                "end_date": filterValues.end_date,
                "subdivision_ids": filterValues.subdivision_ids,
                "status": filterValues.status
            }));
        
            const filteredStatus = filterValues.status && filterValues.status.length > 0
                ? filterValues.status.join(',')
                : null;
        
            params.page_number = 1;
        
            if (Array.isArray(filterValues.subdivision_ids) && filterValues.subdivision_ids.length > 0) {
                params["subdivision_ids"] = filterValues.subdivision_ids.join(',');
            } else {
                delete params["subdivision_ids"];
            }
        
            if (filterValues?.start_date) {
                params["start_date"] = convertDatesToEpochUTC(
                    moment(filterValues.start_date).format('YYYY-MM-DD'),
                    Intl.DateTimeFormat().resolvedOptions().timeZone,
                    true
                );
            } else {
                delete params["start_date"];
            }
        
            if (filterValues?.end_date) {
                params["end_date"] = convertDatesToEpochUTC(
                    moment(filterValues.end_date).format('YYYY-MM-DD'),
                    Intl.DateTimeFormat().resolvedOptions().timeZone,
                    false
                );
            } else {
                delete params["end_date"];
            }
        
            if (filteredStatus) {
                params["status"] = filteredStatus;
            } else {
                delete params["status"];
            }
        
            if (Array.isArray(checkedArr) && checkedArr.length > 0 && !(checkedArr.length === 1 && Array.isArray(checkedArr[0]) && checkedArr[0].length === 0)) {
                params["subdivision_ids"] = checkedArr.join(',');
            } else {
                delete params["subdivision_ids"];
            }
        
            setSearchParams({ ...params });
        }else {
            // Clear filterValues when type is false
            setFilterValues({
                "start_date": '',
                "end_date": '',
                "subdivision_ids": [],
                "status": ""
            });
            dispatch(popFromSubDivArray(['clearall']));

            // Remove filter-related keys from searchParams
            if ("subdivision_ids" in params) {
                delete params["subdivision_ids"];
            }
            if ("status" in params) {
                delete params["status"];
            }
            if ("start_date" in params) {
                delete params["start_date"];
            }
            if ("end_date" in params) {
                delete params["end_date"];
            }

            setSearchParams({ ...params });

        }
    };

    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })

    }

    // handle multi delete
    const handleMultiRowDelete = async () => {
        setLoading(true);
        setMultiDelete(true);
    
        const observernames = selectedRows.map(item => item.name);
        let body = { users: observernames };
    
        const res = await deleteObserver(body);
    
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setIsChangeStatusOpen(false);
            setIsChangeStatusOpenxl(false);
            setLoading(false);
            setMultiDelete(false);
        } else {
            // Get current page_number and total items in the page
            let currentPageNumber = searchParams.get("page_number");
            let totalItemsOnPage = data?.data?.length;
            let selectedCount = observernames.length;
    
            let newSearchParams = new URLSearchParams(searchParams);
    
            // If deleting all items in the current page, move to the previous page
            if (selectedCount === totalItemsOnPage && currentPageNumber > 1) {
                newSearchParams.set("page_number", String(currentPageNumber - 1));
            }
    
    
            // Update URL with the new page_number while keeping other params
            setSearchParams(Object.fromEntries(newSearchParams.entries()));
    
            setToastmessage("Observers deleted successfully");
            setLoading(false);
            setMultiDelete(false);
            setIsChangeStatusOpen(false);
            setIsChangeStatusOpenxl(false);
        }
        dispatch(resetArrays());
        setConfirmationState({});
        setLoading(false);
    };    
            
    const handleDeleteModelClose = () => {
        setConfirmationState({});
        setIsChangeStatusOpen(false);
        setIsChangeStatusOpenxl(false)
        setMultiDelete(false);
    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async (e) => {

        if ((confirmationState?.rowData !== undefined && confirmationState?.rowData !== "" && confirmationState?.rowData?.status === 'active' && textAreaMsg.trim() === '') || (confirmationState?.multirow === "deactive" && (textAreaMsg.trim() === ''))) {
            setToastErrorMessage('Please fill in the mandatory field')

            setEmptyField(true)
            return;
        }
        try {
            let body = {}
            if (confirmationState?.rowData !== undefined && confirmationState?.rowData !== "") {
                {
                    confirmationState?.rowData?.status === 'inactive' ?
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": ''
                        } :
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        }
                }
            }
            else {
                confirmationState?.multirow === "deactive" ?
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg
                    }
                    :
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": ''

                    }
            }
            setLoading(true)


            const activationRes = await editObserver({ body })
            setLoading(false)

            if (activationRes?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                if (confirmationState?.multirow !== "" && confirmationState?.multirow !== undefined) {
                    setToastmessage(`Observers ${confirmationState?.multirow === "active" ? "activated" : "deactivated"} successfully`);
                }
                else {
                    setToastmessage(`Observer ${confirmationState?.rowData?.status === "inactive" ? "activated" : "deactivated"} successfully`);
                }

            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})

        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    useEffect(() => {
        if (searchParams?.get("subdivision_ids") !== null && filtervals?.subdivision_ids !== undefined) {
            dispatch(pushToSubDivArray(['emptyEdit', filtervals?.subdivision_ids?.map(sub => ({
                id: sub,
                name: '',
                isChecked: true,
                isEdit: true
            }))]));
        }


    }, [])

    useEffect(()=>{
        return(()=>{
            dispatch(resetArrays())
        })
    },[])

    const handleDelete = async (username) => {
        setLoading(true);
        
        let body = { users: [username] };
        const res = await deleteObserver(body);
    
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setLoading(false);
            setEmptyField(false);
            setTextAreaMsg("");
            setConfirmationState({});
        } else {
            // Get the current page number from searchParams
            const currentPageNumber = searchParams.get("page_number")
    
            // Get the number of items left on the current page
            const remainingItemsOnPage = data?.data?.length || 0;      
            let newSearchParams = new URLSearchParams(searchParams);
    
            // If only 1 item was left on the page, decrement the page number
            if (remainingItemsOnPage === 1 && currentPageNumber > 1) {
                newSearchParams.set("page_number", currentPageNumber - 1);
            } else {
                newSearchParams.set("page_number", currentPageNumber); // Keep same page if there are more items
            }
        
            // Update the URL with the new page number while keeping all other params intact
            setSearchParams(Object.fromEntries(newSearchParams.entries()));
            setLoading(false);
            setToastmessage("Observer deleted successfully");
            handleConformationClick();
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    const handleOnSearchSubmit = (e) => {
        e.preventDefault();
        
        const searchParams = new URLSearchParams(window.location.search); // Use URLSearchParams
        
        const buildSearchString = (field, value, inverse, domain, forceAtSymbol = false) => {
            if (!value && !domain) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedValue = value === '-' ? '__NULL__' : (value?.trim() || '');
            const formattedDomain = domain === '-' ? '__NULL__' : (domain?.trim() || '');
            
            if (forceAtSymbol) {
                return `${field}=${prefix}${encodeURIComponent(formattedValue)}@${encodeURIComponent(formattedDomain || '')};`;
            }
            
            if (domain) {
                return `${field}=${prefix}${encodeURIComponent(formattedValue)}@${encodeURIComponent(formattedDomain)};`;
            }
            
            return `${field}=${prefix}${encodeURIComponent(formattedValue)};`;
        };
        
        
        const buildPhoneSearchString = (field, code, number, inverse) => {
            if (!code && !number) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedCode = code === '-' ? '__NULL__' : (code || '');
            const formattedNumber = number === '-' ? '__NULL__' : (number || '');
            return `${field}=${prefix}${formattedCode ? '+' : ''}${encodeURIComponent(formattedCode)}-${encodeURIComponent(formattedNumber)};`;
        };
        
        let searchString = "";
        
        searchString += buildSearchString("user_id", organizationUserSearch?.user_id.trim(), organizationUserSearch?.user_id_inverse);
        searchString += buildSearchString("user_name", organizationUserSearch?.user_name.trim(), organizationUserSearch?.user_name_inverse, organizationUserSearch.user_name_domain.trim(),true);
        searchString += buildSearchString("first_name", organizationUserSearch?.first_name.trim(), organizationUserSearch?.first_name_inverse);
        searchString += buildSearchString("last_name", organizationUserSearch?.last_name.trim(), organizationUserSearch?.last_name_inverse);
        searchString += buildSearchString("patient_full_name", organizationUserSearch?.patient_full_name.trim(), organizationUserSearch?.patient_full_name_inverse);
        searchString += buildSearchString("email_address", organizationUserSearch?.email_address, organizationUserSearch?.email_address_inverse, organizationUserSearch.email_address_domain,true);
        searchString += buildPhoneSearchString("mobile_country_code-mobile_number", organizationUserSearch?.mobile_number_code.trim(), organizationUserSearch.mobile_number.trim(), organizationUserSearch.mobile_number_inverse);
        searchString += buildPhoneSearchString("main_country_code-main_number", organizationUserSearch?.main_number_code.trim(), organizationUserSearch.main_number.trim(), organizationUserSearch.main_number_inverse);        
    
        searchString = searchString.slice(0, -1); // Remove trailing ';' (more efficient than endsWith)
        setDatePartialFilled(false)
        const newParams = {
            ...Object.fromEntries(searchParams),
            search: searchString || '',
            search_mode: organizationUserSearch.match === false ? 'and' : 'or',
            sort: searchParams.get('sort') || 'created_at+desc', // Use URLSearchParams.get
            page_number: 1,
            limit: searchParams.get('limit') || '15', // Use URLSearchParams.get
        };
        
        if (!newParams.search) delete newParams.search;
        
        window.history.pushState(null, "", `?${new URLSearchParams(newParams)}`); // Update URL directly
        setSearchParams(newParams); // This triggers the re-render
        dispatch(setOrgUserSearchApplied());
    };
        
    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetOrgUserSearch());
        }
    }, [dispatch, searchApplied]);
    
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Observers"} />
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarIndividual
                            title={'List of Observers'}
                            path={'/manage-observer/add-observer'}
                            AddButton={true}
                            SearchInput={((data?.data?.length === 0 && searchParams.get("search") === null) || data === undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Observer"}
                            menuBar={(data !== undefined && selectedRows?.length > 0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-observer/add-observer'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            setMultiDelete={setMultiDelete}
                            exportCols={['ID', 'Username', 'First Name', 'Last Name', 'Status', 'Alerts by SMS', 'Alerts by Email', 'Include Missed Readings', 'Receive Readings Acknowledgement', 'Patient Associated with', 'Sub Division Name', 'Email Address', 'Mobile Number', 'Main Number', 'Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportObservers={exportObservers}
                            filterValues={filterValues}
                            checkedArr={checkedArr}
                            searchParams={searchParams}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            userArr={userArr}
                            subDivisionDataLoading={subDivisionDataLoading}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected" && !isSortselected) || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Observers list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                handleDelete={handleDelete}
                                loading={loading}
                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {(data?.total_count === 0 && suggestions?.trim() !== "") || data?.success_status === "false" ? (
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                        ) : null}

                        {hasFilters && data?.total_count === 0 ? (
                            <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria."} />
                        ) : null}

                        {data?.total_count === 0 && !searchParams.get("search") && !hasFilters ? (
                            <Emptyscreen
                                title={"Manage Observers"}
                                FirstPTag={"No Observers added yet."}
                                SecondePTag={"Start managing by clicking Add Observer"}
                            />
                        ) : null}

                        {(status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) ? (
                            <SearchEmptyScreen text={"No data found"} />
                        ) : null}
                    </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                disabled={loading}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle={confirmationState?.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === "active" ? 'Activate' : 'Deactivate'}
                                message={confirmationState.rowData !== "" ? `Are you sure you want ${confirmationState?.rowData?.status === "inactive" ? 'activate' : 'deactivate'} the observer?` :
                                    `Are you sure you want to ${confirmationState.multirow === 'active' ? 'activate' : 'deactivate'} the following observers?`}
                                textMessage={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === 'inactive' ? true : false : confirmationState.multirow === "active" ? true : false}
                                buttonName={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === 'active' ? 'Activate' : 'Deactivate'}
                                userList={confirmationState?.multirow === '' ? '' : confirmationState?.multirow === "deactive" ? (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name) : (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name)}
                                loadingActivation={loading}
                            />
                        }
                    />
                }
                {/* delete confirmation prompt */}
                {multiDelete &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleMultiRowDelete}
                            handleClose={handleDeleteModelClose}
                            tittle={'Delete'}
                            message={`Are you sure you want to delete the following observers?`}
                            userList={ selectedRows.map(item => item.name)}
                            buttonName={"Delete"}
                            data_testid="delete-btn"
                            loadingActivation={loading}
                               
                        />
                    }
                />
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit') &&
                <OrganizationUserSearch
                    handleOnSubmit={handleOnSearchSubmit}
                    observerSearch={true}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />}
            </div>
        </>

    )
}


